import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { Typography } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { useLocaleKeys } from '~/i18n';
import EditableTableCell from '../../EditableTableCell/EditableTableCell';
import { draftClientId } from '../draftClient.utils';
import { MainSignatoryModalContent } from './MainSignatoryModalContent/MainSignatoryModalContent';
export const GetMainSignatoryCellTID = (parentTestId)=>getTestIds(parentTestId);
export function MainSignatoryCell(param) {
    let { draft, contact, onOpenModal, isDisabled, disabledTooltip, testId } = param;
    const { MainSignatoryCellTestIds: TID } = useMemo(()=>GetMainSignatoryCellTID(testId), [
        testId
    ]);
    const { t: draftCellsTexts } = useLocaleKeys('pages.draftsDashboard.editTable.draftCells');
    const { t: editTableTexts } = useLocaleKeys('pages.draftsDashboard.editTable');
    const hasClient = draftClientId(draft, contact) != null;
    const openSignatoryModal = ()=>onOpenModal({
            renderContent: (param)=>{
                let { draft: editedDraft, setDraft } = param;
                return {
                    title: draftCellsTexts.mainSignatory(),
                    testId: TID.Modal(),
                    onSubmit: (defaultBehavior)=>void defaultBehavior(),
                    content: /*#__PURE__*/ _jsx(MainSignatoryModalContent, {
                        draft: editedDraft,
                        setDraft: setDraft
                    })
                };
            }
        });
    return /*#__PURE__*/ _jsx(EditableTableCell, {
        testId: TID.Root(),
        onClick: openSignatoryModal,
        isDisabled: isDisabled || !hasClient,
        disabledTooltip: hasClient ? disabledTooltip : draftCellsTexts.mainSignatoryRequiresClient(),
        children: /*#__PURE__*/ _jsx(Typography, {
            ellipsis: true,
            variant: "paragraph2",
            skin: contact ? 'standard' : 'secondary',
            testId: TID.Signatory(),
            children: contact ? "".concat(contact.fullName(), " (").concat(contact.email(), ")") : editTableTexts.notSet()
        })
    });
}
